var map = {
	"./Cruise.jpg": 771,
	"./OpenAI.svg": 772,
	"./Shopify.jpeg": 773,
	"./Snowflake.png": 774,
	"./StabilityAI.jpeg": 775,
	"./Waymo.png": 776,
	"./adobe.png": 777,
	"./adobe.svg": 778,
	"./airbnb-icon.svg": 779,
	"./airbnb.jpeg": 780,
	"./airbnb.svg": 781,
	"./amazon.png": 782,
	"./amazon.svg": 783,
	"./apple.svg": 784,
	"./atlassian.png": 785,
	"./atlassian.svg": 786,
	"./aws.svg": 787,
	"./banner/apple.jpg": 490,
	"./banner/aws.jpg": 491,
	"./banner/cruise.jpg": 492,
	"./banner/facebook.png": 493,
	"./banner/google.jpg": 494,
	"./banner/linkedin.jpg": 495,
	"./banner/microsoft.jpg": 496,
	"./banner/salesforce.jpg": 497,
	"./banner/twitter.jpg": 498,
	"./banner/uber.jpg": 405,
	"./banner/waymo.jpg": 499,
	"./banner/workday.jpg": 500,
	"./coinbase.png": 788,
	"./coinbase.svg": 789,
	"./discord-icon.svg": 790,
	"./discord.svg": 791,
	"./disney.png": 792,
	"./dribbble-icon.svg": 793,
	"./facebook.png": 794,
	"./facebook.svg": 795,
	"./google-icon.svg": 444,
	"./google.svg": 796,
	"./instagram-icon.svg": 797,
	"./instagram.svg": 798,
	"./linkedin.svg": 445,
	"./lyft.png": 799,
	"./meta.png": 800,
	"./microsoft-icon.svg": 446,
	"./microsoft.svg": 801,
	"./netflix-icon.svg": 802,
	"./netflix.jpeg": 803,
	"./netflix.svg": 804,
	"./nvidia.png": 805,
	"./ocinsights.png": 285,
	"./paypal.jpeg": 806,
	"./pinterest-icon.svg": 807,
	"./pinterest.png": 808,
	"./robinhood.png": 809,
	"./salesforce.jpeg": 810,
	"./servicenow.jpeg": 811,
	"./slack-icon.svg": 812,
	"./slack.svg": 813,
	"./snapchat.png": 814,
	"./spotify-icon.svg": 815,
	"./spotify.svg": 816,
	"./square.png": 817,
	"./stripe.svg": 818,
	"./tesla.jpeg": 819,
	"./tesla.svg": 820,
	"./twitter.svg": 821,
	"./uber.svg": 822,
	"./workday.jpeg": 823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 489;